import { useMutation } from "@tanstack/react-query";
import { axiosInstance } from "../../utils/axiosInstance";
import { message } from "antd";
import { queryClient } from "services/queryClient";

export const useMarkAsDelivered = ({ id }: { id: string }) => {
  return useMutation({
    mutationFn: (otp: string) =>
      axiosInstance
        .post(`/orders/${id}/drivers/mark-as-delivered`, { otp })
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {
      queryClient.invalidateQueries({ queryKey: ["useGetDriverOrdersQuery"] });
      message.success(data?.message);
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};

export const useAdminMarkAsDelivered = ({ id }: { id: string }) => {
  return useMutation({
    mutationFn: (otp: string) =>
      axiosInstance
        .post(`/orders/${id}/mark-as-delivered`, { otp })
        .then((res: any) => res.data),
    onSuccess: async (data: any) => {
      queryClient.invalidateQueries({ queryKey: ["useGetDriverOrdersQuery"] });
      message.success(data?.message);
    },
    onError: (error: any) => {
      message.error(error?.response?.data?.message);
    },
  });
};
